import styled from "styled-components";

import { SPACING } from "../../utils/constants";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
`;

export const ValueRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

export const ValueLabel = styled.span`
  font-size: var(--text-md);
  font-weight: 700;
  color: var(--color-primary);
`;

export const Hint = styled.span`
  font-size: var(--text-xs);
  color: var(--color-text-muted);
`;

export const Range = styled.input`
  width: 100%;
  accent-color: var(--color-primary);
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
